import { createRouter, createWebHistory } from "vue-router";

const KioskView = () => import("@/views/KioskView.vue");
const ShopView = () => import("@/views/ShopView.vue");
const SelforderingView = () => import("@/views/SelforderingView.vue");
const MenuView = () => import("@/views/MenuView.vue");
const FinishView = () => import("@/views/FinishView.vue");

const WaitForProviderView = () => import("@/views/WaitForProviderView.vue");

const router = createRouter({
    history: createWebHistory('/'),
    routes: [
        {
            path: "/kiosk/index",
            name: "kiosk",
            component: KioskView,
        },

        // currentl not working because phalcon router catches this routes
        {
            path: "/kiosk/shop",
            name: "delivery",
            component: ShopView,
        },
        {
            path: "/kiosk/order",
            name: "lina-order",
            component: SelforderingView,
        },
        {
            path: "/kiosk/finishPayment",
            name: "final-page",
            component: FinishView,
        },
        {
            path: "/kiosk/waitForProvider",
            name: "wait-page",
            component: WaitForProviderView,
        },
    ],
});

export default router;
